(function($) {
    $(function() {
        try {
            sessionStorage.setItem(
                'Neos.Neos.lastVisitedNode',
                document.querySelector('meta[name="neos-last-visited-node"]').getAttribute('content')
            );
        } catch (e) {
            throw e;
        }
    });
})(jQuery);
